module.exports = __webpack_public_path__ + "img/notice-license.d48c0e77.png";